import type { ComponentChildren, RefObject, JSX } from 'preact';
import { cn } from 'utils/cn';
import { Icon } from 'components/atoms/Icon.tsx';

interface Props {
	inputRef?: RefObject<HTMLInputElement>;
	children?: ComponentChildren;
	className?: string;
	classNameRadioIcon?: string;
	color?: 'red' | 'blue';
	size?: number;
	hasError?: boolean;
	inputProps?: JSX.IntrinsicElements['input'];
}

export function RadioButton({
	children,
	inputRef,
	className,
	classNameRadioIcon,
	color = 'red',
	size = 20,
	inputProps,
	hasError,
	...restProps
}: Props & JSX.IntrinsicElements['input']) {
	const inputColor =
		color === 'red' ? 'peer-checked:text-red text-dark-blue-50' : 'peer-checked:text-dark-blue text-dark-blue-50';
	return (
		<label
			class={cn('inline-flex gap-2 items-center justify-center relative box-content cursor-pointer', className)}
		>
			<span style={{ width: `${size}px`, height: `${size}px` }} className={classNameRadioIcon}>
				<input type="radio" ref={inputRef} class="peer opacity-0 absolute" {...restProps} {...inputProps} />
				<Icon
					className={cn(
						'peer-checked:opacity-100 peer-focus-visible:ring ring-black opacity-0 absolute',
						inputColor,
					)}
					type="radio_button_checked"
					fill
					size={size}
				/>
				<Icon
					className={cn(
						'opacity-100 peer-focus-visible:ring ring-black peer-checked:opacity-0 absolute',
						inputColor,
					)}
					type="radio_button_unchecked"
					size={size}
				/>
			</span>{' '}
			{children}
		</label>
	);
}
